import { Component, ElementRef, Input, Renderer2 } from "@angular/core"
import { types } from "sass"
import Color = types.Color

@Component({
    selector: "hs-card",
    imports: [],
    templateUrl: "./card.component.html",
    styleUrl: "./card.component.scss",
})
export class CardComponent {
    @Input() color: Color

    constructor(
        public renderer: Renderer2,
        public elementRef: ElementRef
    ) {}

    ngOnInit() {
        if (this.color && this.elementRef?.nativeElement?.before)
            this.renderer.setStyle(
                this.elementRef.nativeElement.before,
                "background-color",
                this.color
            )
    }
}
